exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pin[data-v-62ad785c] {\n  top: 8px;\n  right: 9px;\n  position: absolute;\n  -webkit-transform: rotate(35deg);\n          transform: rotate(35deg);\n  font-size: 18px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62ad785c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Offer.vue
// module id = mu3G
// module chunks = 0